class SelectCaratPanel extends Panel {
  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    //super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      if (previousState === 'idle') {
        actions.openRightBottomNav().then(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      }
    });
  }
}
customElements.define('select-carat-panel', SelectCaratPanel);
